<mat-sidenav-container [hasBackdrop]="isMobileView ? sidenavParams.mobileOpened : false"
                       [autosize]="true"
                       class = "sidenav-container"
                       [ngClass] = "{'sidenav-bottom-padded': (!isMobileView && sidenavParams.footerOffset)}"
                       (backdropClick)="onSideNavBackdropClicked($event)">
    <mat-sidenav [opened]="isMobileView ? sidenavParams.mobileOpened : true"
                 [mode]="isMobileView ? 'over' : 'side'"
                 [disableClose]="true"
                 class="sidenav-inner-container"
                 [ngClass]="getSidenavContainerClasses()"
                 (opened)="onSideNavOpened($event)"
                 (closed)="onSideNavClosed($event)"
                 mode="side">
        <div class="sidenav-inner">

            <!-- 'flyout' menu (shows when clicking avatar on collapsed sidenav)-->
            <div *ngIf="!sidenavParams.expanded && !isMobileView && userDesktopMenuOpen"
                class="sidenav-user-desktop-menu" fxLayout="row" fxLayoutAlign="space-between none">
                <div [fxFlex]="sidenavParams.hideChangeCompanyButton ? 100 : 80" fxLayout="column" fxLayoutAlign="center start">
                    <div *ngIf="user" class="sidenav-user-desktop-menu-name">
                        <div class="sidenav-user-desktop-menu-name-item">{{sidenavParams.demoMode ? 'DEMO': ''}}</div>
                        <div class="sidenav-user-desktop-menu-name-item">{{sidenavParams.demoMode ? 'USER': user.name}}</div>
                        <div *ngIf="selectedCompany && !sidenavParams.hideCompanyNameInCompactMode" class="sidenav-user-desktop-menu-company-name">{{selectedCompany.title}}</div>
                    </div>
                </div>
            </div>

            <!-- Header -->
            <div *ngIf="header"
                [ngClass]="{'sidenav-header-collapse': !sidenavParams.expanded, 'sidenav-user-menu-open': userDesktopMenuOpen }"
                class="sidenav-header">
                 <div class="sidenav-header-left">
                     <div *ngIf="header.avatarImageUrl"
                          class="sidenav-avatar-wrapper"
                          [ngClass]="{'sidenav-avatar-mobile': (!sidenavParams.expanded && !isMobileView)}"
                          (click)="onAvatarClicked($event)">
                         <img [src]="header.avatarImageUrl"
                              class="sidenav-avatar">
                     </div>

                     <!-- If there is no avatar url, use abstract avatar icon -->
                     <div *ngIf="!header.avatarImageUrl"
                          class="sidenav-avatar-wrapper-without-url"
                          [ngClass]="{'sidenav-avatar-mobile': (!sidenavParams.expanded && !isMobileView)}"
                          (click)="onAvatarClicked($event)">
                         <div class="material-icons sidenav-avatar-default font">account_circle</div>
                     </div>
                 </div>
                 <div class="sidenav-header-right" [style.display]="isMobileView ? 'block' : sidenavParams.expanded ? 'block' : 'none'">
                     <div class="sidenav-title-container">
                        <div *ngIf="user"
                             class="header-title">
                            <div class="header-title-user">{{sidenavParams.demoMode ? 'DEMO': user.firstName}}</div>
                            <div class="header-title-user">{{sidenavParams.demoMode ? 'USER': user.lastName}}</div>
                        </div>
                        <div *ngIf="header.optionalSubtitle"
                             class="header-subtitle">{{header.optionalSubtitle}}
                        </div>

                    </div>
                </div>
            </div>

            <!-- Body -->
            <div class="sidenav-body">
                <ul>
                    <ng-container
                                  *ngTemplateOutlet="recursiveMenuList; context: {menu: rebuiltMenuConfig, depth: 0}"></ng-container>
                    <ng-template #recursiveMenuList
                                 let-menus="menu"
                                 let-depth="depth">
                        <ng-container *ngFor="let menu of menus">
                            <!-- if collapsed, don't show inline sub menu -->
                            <ng-container *ngIf="!isMobileView && !sidenavParams.expanded">
                                <li *ngIf="menu?.children?.length; else menuItem"
                                    [ngClass]="getMenuItemStyleClasses(menu, depth)"
                                    class="menu-item-overlay">
                                    <button mat-button
                                            [matMenuTriggerFor]="subMenu">
                                            <div class="menu-content">
                                                <mat-icon *ngIf="menu.icon && !menu.isGlyph"
                                                          aria-hidden="false"
                                                          class="menu-icon"
                                                          fontSet="material-icons-outlined"
                                                          [attr.aria-label]="menu.text"
                                                          [fontIcon]="menu.icon">{{menu.icon}}
                                                </mat-icon>
                                                <span *ngIf="menu.isGlyph" icon class="glyphs glyph-icon menu-icon ">{{menu.glyph}}</span> 
                                            </div>
                                    </button>
                                    <mat-menu #subMenu="matMenu"
                                              yPosition="below"
                                              xPosition="after"
                                              [class]="getMenuItemStyleClassesAsString(menu)"
                                              class="sidenav-overlay-menu">
                                              <span #menuText
                                                  class="pop-over-title menu-text">
                                                {{menu.text}}
                                                </span>
                                        <ng-container *ngFor="let subMenu of menu?.children">
                                            <!-- branch -->
                                            <ng-container *ngIf="!subMenu.children?.length">
                                                <button mat-menu-item
                                                        class="sidenav-overlay-menu-item menu-text"
                                                        [ngClass]="getMenuItemOverlayStyleClasses(subMenu)"
                                                        (click)="onMenuItemClicked(subMenu)">
                                                    {{subMenu.text}}
                                                </button>
                                            </ng-container>
                                            <!-- sub menu with children -->
                                            <ng-container *ngIf="subMenu.children?.length">
                                                <button mat-menu-item
                                                        class="sidenav-overlay-menu-item menu-text"
                                                        [matMenuTriggerFor]="subSubMenu">
                                                    <mat-icon *ngIf="subMenu.icon"
                                                              aria-hidden="false"
                                                              class="sidenav-overlay-menu-item-icon"
                                                              fontSet="material-icons-outlined"
                                                              [attr.aria-label]="subMenu.text"
                                                              [fontIcon]="menu.icon">{{subMenu.icon}}</mat-icon>
                                                    {{subMenu.text}}
                                                </button>
                                                <mat-menu #subSubMenu="matMenu"
                                                          yPosition="below"
                                                          xPosition="after"
                                                          class="sidenav-overlay-submenu">
                                                    <ng-container *ngFor="let subSubMenu of subMenu?.children">
                                                        <!-- sub branch, sub-sub menu item without children -->
                                                        <ng-container *ngIf="!subSubMenu.children?.length">
                                                            <button mat-menu-item
                                                                    class="sidenav-overlay-menu-item menu-text"
                                                                    (click)="onMenuItemClicked(subSubMenu)">
                                                                <mat-icon *ngIf="subSubMenu.icon"
                                                                          aria-hidden="false"
                                                                          class="sidenav-overlay-menu-item-icon"
                                                                          fontSet="material-icons-outlined"
                                                                          [attr.aria-label]="subSubMenu.text"
                                                                          [fontIcon]="subSubMenu.icon">{{subSubMenu.icon}}</mat-icon>
                                                                {{subSubMenu.text}}
                                                            </button>
                                                        </ng-container>
                                                    </ng-container>
                                                </mat-menu>
                                            </ng-container>
                                        </ng-container>
                                    </mat-menu>
                                </li>
                            </ng-container>

                            <!-- Standard inline menu -->
                            <ng-container *ngIf="isMobileView || sidenavParams.expanded">

                                <li *ngIf="menu?.children?.length; else menuItem"
                                class="menu-item-expandable"
                                [ngClass]="getMenuItemStyleClasses(menu, depth)"
                                (click)="onParentMenuItemClicked(menu)">
                                <button fxLayout="row" fxLayoutAlign="space-between center"
                                [ngStyle]="{'padding-left': (depth * sidenavParams.childIndentValue) + 'rem'}"
                                class="menu-item-button"
                                        mat-button>
                                    <div class="menu-content">
                                        <mat-icon *ngIf="menu.icon && !menu.isGlyph"
                                                  aria-hidden="false"
                                                  class="menu-icon"
                                                  fontSet="material-icons-outlined"
                                                  [attr.aria-label]="menu.text"
                                                  [fontIcon]="menu.icon">{{menu.icon}}</mat-icon>
                                        <span *ngIf="menu.isGlyph" icon class="glyphs glyph-icon menu-icon ">{{menu.glyph}}</span> 
                                        <span #menuText class="menu-text" *ngIf="menu.text && (isMobileView ? true : sidenavParams.expanded)"
                                                [ngStyle]="getParentMenuMaxWidth(depth)"
                                                [matTooltip]="menu.text" showTooltipIfTruncated
                                                matTooltipPosition="right"
                                                [matTooltipDisabled]="isMobileView"
                                                matTooltipClass="sidenav-menu-item sidenav-parent-menu-item">
                                            {{menu.text}}
                                        </span>
                                    </div>
                                    <mat-icon *ngIf="(isMobileView ? true : sidenavParams.expanded)" class="expand-menu-icon">
                                        {{menu.isExpanded ? 'expand_less' : 'expand_more'}}
                                    </mat-icon>
                                </button>
                            </li>
                            <ul *ngIf="menu.isExpanded">
                                <ng-container
                                              *ngTemplateOutlet="recursiveMenuList; context:{ menu: menu?.children,  depth: depth + 1 }">
                                </ng-container>
                            </ul>

                            </ng-container>

                            <!-- single menu items (no dropdown) -->
                            <ng-template #menuItem>
                                <!-- desktop collapsed sidenav item-->
                                <ng-container *ngIf="!sidenavParams.expanded">
                                    <li class="menu-item-branch"
                                    [ngClass]="getMenuItemStyleClasses(menu, depth)"
                                    >
                                        <button [ngStyle]="{'padding-left': (depth * sidenavParams.childIndentValue) + 'rem'}"
                                                class="menu-item-button"
                                                mat-button
                                                (click)="onMenuItemClicked(menu)">
                                                <div class="menu-content"
                                                    [matTooltip]="menu.text"
                                                    matTooltipPosition="right"
                                                    matTooltipClass="sidenav-menu-collapsed-item menu-text">
                                                    <mat-icon *ngIf="menu.icon && !menu.isGlyph"
                                                    aria-hidden="false"
                                                    [attr.aria-label]="menu.text"
                                                    class="menu-icon"
                                                    fontSet="material-icons-outlined"
                                                    [fontIcon]="menu.icon">
                                                        {{menu.icon}}
                                                    </mat-icon>
                                                    <span *ngIf="menu.isGlyph" icon class="glyphs glyph-icon menu-icon ">{{menu.glyph}}</span> 
                                            </div>
                                        </button>
                                    </li>
                                </ng-container>

                                <!-- mobile / desktop expanded sidnav item -->
                                <ng-container *ngIf="sidenavParams.expanded">
                                    <li class="menu-item-branch"
                                    [ngClass]="getMenuItemStyleClasses(menu, depth)"
                                    >
                                    <button [ngStyle]="{'padding-left': (depth * sidenavParams.childIndentValue) + 'rem'}"
                                            class="menu-item-button"
                                            mat-button
                                            (click)="onMenuItemClicked(menu)">
                                            <div class="menu-content">
                                                <mat-icon *ngIf="menu.icon && !menu.isGlyph"
                                                          aria-hidden="false"
                                                          [attr.aria-label]="menu.text"
                                                          class="menu-icon"
                                                          fontSet="material-icons-outlined"
                                                          [fontIcon]="menu.icon">{{menu.icon}}</mat-icon>
                                                <span *ngIf="menu.isGlyph" icon class="glyphs glyph-icon menu-icon ">{{menu.glyph}}</span> 
                                                <span #menuText class="menu-text" *ngIf="menu.text && (isMobileView ? true : sidenavParams.expanded)"
                                                    [matTooltip]="menu.text" showTooltipIfTruncated
                                                    matTooltipPosition="right"
                                                    matTooltipClass="sidenav-menu-item"
                                                    [matTooltipDisabled]="isMobileView"
                                                    [ngStyle]="getNestedMenuMaxWidth(depth, !!menu.icon)">
                                                    {{menu.text}}
                                                </span>
                                            </div>
                                        </button>
                                    </li>
                                </ng-container>
                            </ng-template>
                        </ng-container>
                    </ng-template>
                </ul>
            </div>
            <!-- Footer -->
            <div *ngIf="footer"
                 class="sidenav-footer">
                <button *ngFor="let item of footer.items"
                        mat-button
                        [class]="sidenavParams.expanded ? 'footer-menu-item-expanded':'footer-menu-item-collapsed'"
                        (click)="onFooterItemClick(item)">
                    <mat-icon *ngIf="item?.icon"
                              aria-hidden="false"
                              [attr.aria-label]="item?.text"
                              class="footer-menu-icon"
                              fontSet="material-icons-outlined"
                              [fontIcon]="item?.icon">{{item?.icon}}</mat-icon>

                    <span *ngIf="item?.text && sidenavParams.expanded" class="menu-text">
                        {{item.text}}
                    </span>
                </button>
                <div *ngIf="!sidenavParams.hideLogoutButton">
                    <zui-sidenav-login-button [isMenuItem]="true" [isExpanded]="sidenavParams.expanded"></zui-sidenav-login-button>
                </div>
                <!--Expand/Collapse-->
                <div class="collapse-button-container">
                    <button *ngIf="!isMobileView && (!sidenavParams.lockExpansion && sidenavParams.expanded)"
                            mat-button
                            class="collapse-button-expanded"
                            (click)="closeDrawer($event)">
                        <mat-icon aria-hidden="false"
                                  class="collapse-button-expanded-icon"
                                  aria-label="Collapse"
                                  fontIcon="chevron_left">arrow_back_ios</mat-icon>
                        <span class="menu-text">Collapse</span>
                    </button>
                    <button *ngIf="!isMobileView && (!sidenavParams.lockExpansion && !sidenavParams.expanded)"
                            mat-button
                            matTooltip="Expand Navigation Bar"
                            matTooltipPosition="right"
                            matTooltipClass="collapse-button-tooltip"
                            [matTooltipDisabled]="isMobileView"
                            class="collapse-button-collapsed"
                            (click)="openDrawer($event)">
                        <mat-icon aria-hidden="false"
                                  aria-label="Expand Navigation Bar"
                                  class="collapse-button-collapsed-icon"
                                  fontIcon="chevron_right">chevron_right</mat-icon>
                    </button>
                    <!-- we will still show a collapse button to close the drawer 
                        if we don't want the sidenav to expand and collapse to the icon level  -->
                    <button *ngIf="isMobileView"
                            class="collapse-button-collapsed-mobile"
                            mat-button
                            (click)="onCloseSidenavClicked($event)">
                        <mat-icon aria-hidden="false"
                                  aria-label="Collapse"
                                  class="collapse-button-collapsed-mobile-icon"
                                  fontIcon="chevron_left">chevron_left</mat-icon>
                        <span class="menu-text">Collapse</span>
                    </button>
                </div>
            </div>
        </div>
    </mat-sidenav>

    <mat-sidenav-content [ngStyle]="getSidenavContentMargin()"
                         (click)="onSidenavContentClicked()">
        <ng-content></ng-content>
    </mat-sidenav-content>
</mat-sidenav-container>